'use strict';

var $ = require('jquery');
var _ = require('underscore');
var Backbone = require('backbone');

var RadioView = require('./radio').default;

export default Backbone.View.extend({

  tagName: 'div',

  attributes: {
    class: 'choices',
  },

  items: [],

  initialize: function (options) {
    this.responseId = options.responseId;
    this.question = options.question;
    this.answer = options.answer;

    this.$el.prop('id', this.question.get('id'));

    this._buildOptions();
  },

  _buildOptions: function () {
    var self = this;

    if ($.type(this.question.get('options')) === 'string') {
      var options = $.parseJSON(this.question.get('options'));
    } else {
      var options = this.question.get('options');
    }

    self.items = [];
    _.each(options, function (option) {

      var checked = false;
      if (self.answer && self.answer.indexOf(option.value) != -1) {
        checked = true;
      }

      var radio = new RadioView({
        option: option,
        name: self.responseId,
        checked: checked,
        required: self.question.get('required'),
      });

      self.items.push(radio);
    });
  },

  render: function () {
    var self = this;

    _.each(self.items, function (radio) {
      var rendered = radio.render();

      var div = $('<div />', {class: 'radio'});
      var label = $('<label />', {for: rendered.$el.attr('id'), text: radio.text});

      div.append(rendered.el);
      div.append(label);

      self.$el.append(div);
    });

    return this;
  },
});
